import { createPlatformStyles, theme } from "../../../theme/theme";

export const { styles, ids } = createPlatformStyles({
  mobile: {
    containerStyle: {},
    innerContainer: {},
    termsPolicy: {
      backgroundColor: theme.colors.qrBackground,
      height: 50,
      zIndex: 9,
      bottom: 0,
      left: 0,
      right: 0,
      position: "absolute",
      display: "flex",
      flexDirection: "row",
      justifyContent: "center",
      alignItems: "center",
    },
  },
  web: {
    containerStyle: {
      marginTop: 0,
      width: "100",
    },
    innerContainer: { position: "absolute", width: "100%", bottom: "5%" },
    termsPolicy: {
      height: 60,
      zIndex: 9,
      bottom: 0,
      left: 0,
      right: 0,
      display: "flex",
      flexDirection: "row",
      justifyContent: "center",
      alignItems: "center",
      gap: theme.spacing.md,
      width: "100%",
    },
  },
});
